<template>
  <div v-if="showNotice" class="stickynotice bluesticky">
    <div class="stickynotice-text" v-html="theNotice" />
    <div class="stickynotice-close" @click="closeCookieNotice">
      OK
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    showNotice() {
      if (this.$route.query.langdisabled) {
        return true;
      }
    },
    theNotice() {
      if (this.$route.query.langdisabled === '2') {
        return "Pour un service en Fran&#231;ais, n'h&#233;sitez pas &#224; nous contacter par t&#233;l&#233;phone au num&#233;ro ci-dessous";
      }
      if (this.$route.query.langdisabled === '3') {
        return 'F&#252;r eine Beratung auf deutsch kontaktieren Sie bitte unser Team unter der folgenden Nummer';
      }
    },
  },
  methods: {
    closeCookieNotice(ev) {
      this.$router.push({ path: '/' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../assets/styles/settings/config.scss';
@import '../assets/styles/components/stickynotice.scss';

.bluesticky {
  background: $darkBlack;
}

</style>
